<template>
  <aside v-if="user" class="sidebar sidebar-left">
    <div class="sidebar-profile">
      <div class="avatar logo-wrapper">
        <v-skeleton-loader
        type="list-item-two-line"
        :loading="!menu"
        transition="scale-transition"
        dark
        >
        <img
          class="sidebar-logo"
          :src="logo"
          alt="logo"
        >
        </v-skeleton-loader>
      </div>
      <div class="profile-body dropdown">
          <a :title="title"><h4>{{ title }}</h4></a>
          <h4 :title="user.dealer.razonSocial">{{ user.dealer.razonSocial }}</h4>
      </div>
    </div>
    <nav>
      <v-skeleton-loader
        type="list-item-two-line"
        :loading="!menu"
        transition="scale-transition"
        dark
      >
        <sidebar-menu
        :class="`sidebar-menu ${sidebarColor}`"
        :menu="menu" width="240px" :relative="true" :hideToggle="true" />
      </v-skeleton-loader>
    </nav>
  </aside>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  data: () => ({
    appName: window.config.appName,
    opened: false,
    dialog: false,
    menu: null,
    type: 'D',
    logo: '',
    title: '',
  }),

  computed: mapGetters({
    user: 'auth/user',
    permissions: 'auth/permissions',
    params: 'auth/params',
    sidebarColor: 'theme/sidebarColor',
  }),

  watch: {
    user: {
      handler() {
        this.init();
      },
      deep: true,
    },
  },

  async mounted() {
    await this.$store.dispatch('auth/fetchParams');
    this.init();
  },

  methods: {
    async logout() {
      this.dialog = false;
      // Log out the user.
      await this.$store.dispatch('auth/logout');

      // Redirect to login.
      this.$router.push({ name: 'login' });
    },

    init() {
     [this.logo, this.title] = [this.params[0], this.params[1]];
     if (this.user) {
        window.axios.get(`/api/permissions/${this.type}`)
        .then((result) => {
          let nombreMenu = result.data.map((item) => {
            if (!item.child) {
              if (this.permissions.filter((permission) => permission.name === item.url).length > 0) {
                item.icon = { class: item.icon, attributes: { title: item.title } };
                return item;
              }
              return null;
            }
            if (this.permissions.filter((permission) => permission.name === item.url).length > 0) {
              let childs = item.child.map((child) => {
                if (this.permissions.filter((permission) => permission.name === child.url).length > 0) {
                  child.icon = { class: child.icon, attributes: { title: child.title } };
                  return child;
                }
                return null;
              });
              delete item.child;
              childs = childs.filter((child) => child != null);
              item.child = childs;
              return item;
            }
            return null;
          });
          nombreMenu = nombreMenu.filter((menu) => menu != null);
          this.menu = nombreMenu;
        });
      }
    },
  },
};
</script>

<style>
  .sidebar-profile .logo-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    padding: 8px 0;
  }
  .sidebar-profile .sidebar-logo {
    display: block;
    max-width: 90%;
    max-height: 80px;
    width: auto;
    height: auto;
    margin: auto;
    object-fit: contain;
  }
  .sidebar-profile .profile-body {
    min-width: 0;
    max-width: 100%;
    overflow: hidden;
  }
  .sidebar-profile .profile-body a {
    display: block;
    max-width: 100%;
    overflow: hidden;
  }
  .sidebar-profile .profile-body h4 {
    max-width: 100%;
    margin: 10px 0 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .v-sidebar-menu .vsm--link_level-2 .vsm--icon{
    height: 30px;
    line-height: 30px;
    width: 30px;
  }
  .v-sidebar-menu .vsm--link_level-1 {
    padding: 5px !important;
  }
  .v-sidebar-menu .vsm--link_level-2 {
    padding: 5px !important;
  }
</style>
